// extracted by mini-css-extract-plugin
export default {"hardness":"tsINN","popoverInfo":"JxY3G","popover":"fEuzS","name":"wjlYB","icon":"YN_oO","value":"mM98u","text":"Nzt6O"};